// QuickActionsContainer.jsx
import React from 'react';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FlashOn as FlashOnIcon } from '@material-ui/icons';
import QuickActionCards from './QuickActionCards';

// Debug configuration
const DEBUG = true;
const log = (...args) => {
    if (DEBUG) {
        console.log('[QuickActionsContainer]', ...args);
    }
};

const styles = (theme) => ({
    root: {
        width: '100%',
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        position: 'relative',
        '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: '1.75%',
            width: '96.5%',
            height: '2px',
            backgroundColor: 'rgba(51, 51, 51, 0.3)',
        },
    },
    title: {
        fontWeight: 'bold',
        color: '#333',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0),
    },
    lightningIcon: {
        fontSize: '2rem',
        color: '#00BBEB',
        display: 'flex',
        alignItems: 'center',
        marginTop: '6px',
    },
});

const QuickActionsContainer = ({ classes, quickActions, loading, error }) => {
    log('QuickActionsContainer received props:', {
        quickActions,
        quickActionsLength: quickActions ? quickActions.length : 'undefined',
        loading,
        error
    });

    return (
        <div className={classes.root}>
            <div className={classes.titleContainer}>
                <Typography variant="h5" className={classes.title}>
                    <FlashOnIcon className={classes.lightningIcon} />
                    Quick Actions
                </Typography>
            </div>
            <QuickActionCards 
                quickActions={quickActions}
                loading={loading}
                error={error}
            />
        </div>
    );
};

export default withStyles(styles)(QuickActionsContainer);